// Module
var code = ` <span title="{{ \$ctrl.curr.cv.estado }}">{{ \$ctrl.stateDesc }}</span> <span ng-if="::!\$ctrl.simple"><br/> {{ \$ctrl.curr.cv.revisor }} <br/> {{ \$ctrl.curr.cv.fcrevision | date : 'dd MMM yy HH:mm' }}</span> `;
// Exports
module.exports = code;